import { AccountProductPreferences } from "../../hooks/useAccountProductPreferences";
import { ItemShadeType } from "/@/generated/graphql";

export type GeneralPreferenceValues = {
  fixedShadeType: ItemShadeType | undefined;
  removableShadeType: ItemShadeType | undefined;
  occlusion: string;
  contactPoints: string;
  cervicalLimit: string;
  labInstructions: string[];
  labNote: string;
  mobileNumber: string;
  smsNotifications: string[];
};

export const getGeneralPreferenceDefaults = (
  preferences: AccountProductPreferences | undefined
): GeneralPreferenceValues => ({
  fixedShadeType: preferences?.shadeType,
  removableShadeType: undefined,
  occlusion: "",
  contactPoints: "",
  cervicalLimit: "",
  labInstructions: [],
  labNote: "",
  mobileNumber: "",
  smsNotifications: [],
});

export const toggleValue = (values: string[], value: string) =>
  values.includes(value)
    ? values.filter(current => current !== value)
    : [...values, value];
